// extracted by mini-css-extract-plugin
export var container = "_uv-0";
export var table = "_uv-2";
export var tableWrapper = "_uv-1";